/*
- This entry is output as spa-ck-plugins
*/
// import './ajax';
import './autocorrect';
import './autogrow';
import './basicstyles';
import './button';
import './citationContextMenu';
import './clipboard';
import './contextmenu';
import './editorPlaceholder';
import './enterkey';
import './fakeObjects';
import './figureTools';
import './floatpanel';
import './indent';
import './indentList';
import './indentParagraph';
import './justify';
import './lineutils';
import './list';
import './magicline';
import './menu';
import './outlineCitation';
import './outlineDropContent';
import './pagebreak';
import './panel';
import './paperDropOutlineNode';
import './paperDropResearchNote';
import './perrlaFootnotes';
import './perrlaReferences';
import './preview';
import './printDocument';
import './removeformat';
import './saveDocument';
import './saveFootnotes';
import './saveOutline';
import './sourcearea';
import './tableTools';
import './toolbar';
import './undo';
import './widget';
import './widgetSelection';
import './wysiwygArea';
import './xml';


// ckEditor's language file - instead of loading a separate js file bundle it here
CKEDITOR.lang['en'] = {"application":"Rich Text Editor","editor":"Editor","editorPanel":"Rich Text Editor panel","common":{"editorHelp":"Press ALT 0 for help","browseServer":"Browse Server","url":"URL","protocol":"Protocol","upload":"Upload","uploadSubmit":"Send it to the Server","image":"Image","form":"Form","checkbox":"Checkbox","radio":"Radio Button","textField":"Text Field","textarea":"Textarea","hiddenField":"Hidden Field","button":"Button","select":"Selection Field","imageButton":"Image Button","notSet":"<not set>","id":"Id","name":"Name","langDir":"Language Direction","langDirLtr":"Left to Right (LTR)","langDirRtl":"Right to Left (RTL)","langCode":"Language Code","longDescr":"Long Description URL","cssClass":"Stylesheet Classes","advisoryTitle":"Advisory Title","cssStyle":"Style","ok":"OK","cancel":"Cancel","close":"Close","preview":"Preview","resize":"Resize","generalTab":"General","advancedTab":"Advanced","validateNumberFailed":"This value is not a number.","confirmNewPage":"Any unsaved changes to this content will be lost. Are you sure you want to load new page?","confirmCancel":"You have changed some options. Are you sure you want to close the dialog window?","options":"Options","target":"Target","targetNew":"New Window (_blank)","targetTop":"Topmost Window (_top)","targetSelf":"Same Window (_self)","targetParent":"Parent Window (_parent)","langDirLTR":"Left to Right (LTR)","langDirRTL":"Right to Left (RTL)","styles":"Style","cssClasses":"Stylesheet Classes","width":"Width","height":"Height","align":"Alignment","left":"Left","right":"Right","center":"Center","justify":"Justify","alignLeft":"Align Left","alignRight":"Align Right","alignCenter":"Align Center","alignTop":"Top","alignMiddle":"Middle","alignBottom":"Bottom","alignNone":"None","invalidValue":"Invalid value.","invalidHeight":"Height must be a number.","invalidWidth":"Width must be a number.","invalidLength":"Value specified for the \"%1\" field must be a positive number with or without a valid measurement unit (%2).","invalidCssLength":"Value specified for the \"%1\" field must be a positive number with or without a valid CSS measurement unit (px, %, in, cm, mm, em, ex, pt, or pc).","invalidHtmlLength":"Value specified for the \"%1\" field must be a positive number with or without a valid HTML measurement unit (px or %).","invalidInlineStyle":"Value specified for the inline style must consist of one or more tuples with the format of \"name : value\", separated by semi-colons.","cssLengthTooltip":"Enter a number for a value in pixels or a number with a valid CSS unit (px, %, in, cm, mm, em, ex, pt, or pc).","unavailable":"%1<span class=\"cke_accessibility\">, unavailable</span>","keyboard":{"8":"Backspace","13":"Enter","16":"Shift","17":"Ctrl","18":"Alt","32":"Space","35":"End","36":"Home","46":"Delete","112":"F1","113":"F2","114":"F3","115":"F4","116":"F5","117":"F6","118":"F7","119":"F8","120":"F9","121":"F10","122":"F11","123":"F12","124":"F13","125":"F14","126":"F15","127":"F16","128":"F17","129":"F18","130":"F19","131":"F20","132":"F21","133":"F22","134":"F23","135":"F24","224":"Command"},"keyboardShortcut":"Keyboard shortcut","optionDefault":"Default"}};

// add to the object above - the lang folder in the plugin you downloaded goes here
CKEDITOR.lang['en']['contextmenu'] = {
	options: 'Context Menu Options'
}
CKEDITOR.lang['en']['fakeobjects'] = {
	anchor: 'Anchor',
	hiddenfield: 'Hidden Field',
	iframe: 'IFrame',
	unknown: 'Unknown Object'
}
CKEDITOR.lang['en']['magicline'] = {
	title: 'Insert paragraph here'
}
CKEDITOR.lang['en']['pagebreak'] = {
	alt: 'Page Break',
	toolbar: 'Insert Page Break for Printing'
}
CKEDITOR.lang['en']['removeformat'] = {
	toolbar: 'Remove Format'
}
CKEDITOR.lang['en']['toolbar'] = {
	toolbarCollapse: 'Collapse Toolbar',
	toolbarExpand: 'Expand Toolbar',
	toolbarGroups: {
		document: 'Document',
		clipboard: 'Clipboard/Undo',
		editing: 'Editing',
		forms: 'Forms',
		basicstyles: 'Basic Styles',
		paragraph: 'Paragraph',
		links: 'Links',
		insert: 'Insert',
		styles: 'Styles',
		colors: 'Colors',
		tools: 'Tools'
	},
	toolbars: 'Editor toolbars'
}
CKEDITOR.lang['en']['undo'] = {
	redo: 'Redo',
	undo: 'Undo'
}

CKEDITOR.config.specialChars = [
	// '!', '&quot;', '#', '$', '%', '&amp;', "'", '(', ')', '*', '+', '-', '.', '/',
	// '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ':', ';',
	// '&lt;', '=', '&gt;', '?', '@',
	// 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O',
	// 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
	// '[', ']', '^', '_', '`',
	// 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p',
	// 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
	// '{', '|', '}', '~',
	'&euro;',
	// '&lsquo;', '&rsquo;', '&ldquo;', '&rdquo;',
	'&ndash;', '&mdash;', '&le;', '&ge;',
	'&iexcl;', '&cent;', '&pound;',
	'&curren;', '&yen;', '&brvbar;', '&sect;', '&uml;', '&copy;', '&ordf;', '&laquo;', '&not;', '&reg;', '&macr;',
	'&deg;', '&sup2;', '&sup3;', '&acute;', '&micro;', '&para;', '&middot;', '&cedil;', '&sup1;', '&ordm;', '&raquo;',
	'&frac14;', '&frac12;', '&frac34;', '&iquest;', '&Agrave;', '&Aacute;', '&Acirc;', '&Atilde;', '&Auml;', '&Aring;',
	'&AElig;', '&Ccedil;', '&Egrave;', '&Eacute;', '&Ecirc;', '&Euml;', '&Igrave;', '&Iacute;', '&Icirc;', '&Iuml;',
	'&ETH;', '&Ntilde;', '&Ograve;', '&Oacute;', '&Ocirc;', '&Otilde;', '&Ouml;', '&times;', '&Oslash;', '&Ugrave;',
	'&Uacute;', '&Ucirc;', '&Uuml;', '&Yacute;', '&THORN;', '&szlig;', '&agrave;', '&aacute;', '&acirc;', '&atilde;',
	'&auml;', '&aring;', '&aelig;', '&ccedil;', '&egrave;', '&eacute;', '&ecirc;', '&euml;', '&igrave;', '&iacute;',
	'&icirc;', '&iuml;', '&eth;', '&ntilde;', '&ograve;', '&oacute;', '&ocirc;', '&otilde;', '&ouml;', '&divide;',
	'&oslash;', '&ugrave;', '&uacute;', '&ucirc;', '&uuml;', '&yacute;', '&thorn;', '&yuml;', '&OElig;', '&oelig;',
	'&#372;', '&#374', '&#373', '&#375;', '&sbquo;', '&#8219;', '&bdquo;', '&hellip;', '&trade;', '&#9658;', '&bull;',
	'&rarr;', '&rArr;', '&hArr;', '&diams;', '&asymp;'
];